import { render } from "./MatchChartPage.vue?vue&type=template&id=2cae6ac8&scoped=true"
import script from "./MatchChartPage.vue?vue&type=script&lang=js"
export * from "./MatchChartPage.vue?vue&type=script&lang=js"

import "./MatchChartPage.vue?vue&type=style&index=0&id=2cae6ac8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cae6ac8"]])

export default __exports__